import { useState } from "react";
import { formatDistanceToNowStrict } from "date-fns";

import { Button } from "@acme/ui/button";

export function DebugInfo({
  sessionExpiresAt,
  locale,
  timeZone,
  currency,
  userId,
  distinctId,
}: {
  sessionExpiresAt?: number;
  locale: string;
  timeZone: string;
  currency: string;
  userId: string;
  distinctId?: string;
}) {
  const [isVisible, setIsVisible] = useState(false);

  return (
    <div className="text-muted-foreground fixed right-4 bottom-4 text-right">
      <Button
        variant="ghost"
        size="sm"
        onClick={() => setIsVisible(!isVisible)}
        className="mb-2"
      >
        {isVisible ? "Hide Debug" : "Debug"}
      </Button>
      {isVisible && (
        <div className="text-xs">
          {sessionExpiresAt && (
            <div>
              Session expires in:{" "}
              {formatDistanceToNowStrict(sessionExpiresAt, {
                unit: "day",
                addSuffix: true,
              })}
            </div>
          )}
          <div>Locale: {locale}</div>
          <div>Timezone: {timeZone}</div>
          <div>Currency: {currency}</div>
          <div>User ID: {userId}</div>
          {distinctId && <div>Distinct ID: {distinctId}</div>}
        </div>
      )}
    </div>
  );
}
